import React from "react";
import { Link } from "gatsby";

const Footer = () => {
  return (
    <>
      <footer className="footer">
        <div>
          <Link to="/" className="logo">
            <img src="/assets/icons/logo.png" alt="Bad bunnies logo" />
          </Link>
          <h2>
            Bad Bunnies
            <br />
            PAW WARZ
          </h2>
        </div>
        <div className="footer-links">
          <div className="footer-column">
            <p>Cards</p>
            <Link to="/mint" className="footer-link">
              Mint Packs
            </Link>
            <Link to="/farm/mint" className="footer-link">
              Mint Farms
            </Link>
            <Link to="/cards" className="footer-link">
              Cards
            </Link>
            <Link to="/tcg" className="footer-link">
              Buy Physical
            </Link>
            <Link to="/marketplace" className="footer-link">
              Marketplace
            </Link>
          </div>
          <div className="footer-column">
            <p>Game</p>
            <Link to="/battlepass" className="footer-link">
              Battlepass
            </Link>
            <Link to="/gangs" className="footer-link">
              Gangs
            </Link>
            <Link to="/how-to" className="footer-link">
              Gameplay
            </Link>
            <Link to="/cabbage-shop" className="footer-link">
              Cabbage shop
            </Link>
          </div>
          <div className="footer-column">
            <p>My Stuff</p>
            <Link to="/my/account" className="footer-link">
              My Account
            </Link>
            <Link to="/my/cards" className="footer-link">
              My Cards
            </Link>
            <Link to="/my/packs" className="footer-link">
              My Packs
            </Link>
            <Link to="/my/rewards" className="footer-link">
              My Rewards
            </Link>
            <Link to="/my/decks" className="footer-link">
              My Decks
            </Link>
          </div>
          <div className="footer-column">
            <p>Other Stuff</p>
            <Link to="/contact" className="footer-link">
              Contact
            </Link>
            <Link to="/terms-and-conditions" className="footer-link">
              Terms & Conditions
            </Link>
            <a href="https://medium.com/@BadBunniesNFT" target="_blank" className="footer-link">
              Blog
            </a>
            <Link to="/faq" className="footer-link">
              FAQs
            </Link>
            <a
              href="https://pawwarztcg.myshopify.com/collections/bad-bunnies-paw-warz-season-01-collection"
              target="_blank"
              className="footer-link"
            >
              Merch
            </a>
          </div>
        </div>
      </footer>
      <p className="copyright">Copyright © BAD LABS PTY LTD. All rights reserved</p>
    </>
  );
};

export default Footer;
